<template>
  <div class="counterparty-create-container">
    <h2 class="counterparty-title">Создание нового контрагента</h2>

    <base-loader v-if="dataIsLoading" />
    <form
      :id="formId"
      @submit.prevent="createCounterparty"
      class="card counterparty-form"
      v-else
    >
      <counterparty-create-form
        class="counterparty-block"
        :formData="formData"
        @update:formData="updateFormData"
        ref="formRef"
      />

      <requisite-create
        ref="requisiteCreateRef"
        :allowed-models="['Counterparty']"
        :requisitable-type="'Counterparty'"
        :form-id="formId"
      />

      <div class="form-actions">
        <base-primary-button
          class="form-btn"
          type="submit"
          :form="formId"
          :disabled="isSubmitting"
        >
          <span v-if="isSubmitting">Сохранение...</span>
          <span v-else>Сохранить</span>
        </base-primary-button>

        <base-button
          class="form-btn"
          type="button"
          @click="handleCancel"
          :disabled="isSubmitting"
        >
          Отмена
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { reactive } from "vue";

import { getCompanyId } from "@/utils/userUtils";
import { useNotificationStore } from "@/stores/notificationStore";

import counterpartiesApi from "@/services/api/counterpartiesApi";

import CounterpartyCreateForm from "@/components/Counterparty/CounterpartyCreateForm.vue";
import RequisiteCreate from "@/components/Requisite/RequisiteCreate.vue";

export default {
  name: "CounterpartyCreatePage",
  components: {
    CounterpartyCreateForm,
    RequisiteCreate,
  },
  data() {
    return {
      dataIsLoading: false,
      isSubmitting: false,
      formId: "counterparty-create-form",

      companyId: getCompanyId(),

      formData: reactive({
        name: "",
        inn: "",
        kpp: "",
        phone: "",
        email: "",
        city: "",
        street: "",
        house: "",
        legal_address: "",
        postal_address: "",
        postal_code: "",
        region_code: "",
        bank_name: "",
        bik: "",
        account_number: "",
        correspondent_account: "",
      }),
    };
  },

  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },

  methods: {
    updateFormData(newData) {
      Object.assign(this.formData, newData);
    },

    async createCounterparty() {
      const formComponent = this.$refs.formRef;

      let isFormValid = true;
      if (
        formComponent &&
        typeof formComponent.validate === "function"
      ) {
        isFormValid = await formComponent.validate();
      }

      if (!isFormValid) {
        this.notificationStore.showError(
          "Пожалуйста, заполните все обязательные поля корректно"
        );
        return;
      }

      try {
        this.isSubmitting = true;

        const payload = {
          name: this.formData.name,
          inn: this.formData.inn,
          kpp: this.formData.kpp,
          phone: this.formData.phone,
          email: this.formData.email,
          city: this.formData.city,
          street: this.formData.street,
          house: this.formData.house,
          legal_address: this.formData.legal_address,
          postal_address: this.formData.postal_address,
          postal_code: this.formData.postal_code,
          region_code: this.formData.region_code,
          bank_name: this.formData.bank_name,
          bik: this.formData.bik,
          account_number: this.formData.account_number,
          correspondent_account: this.formData.correspondent_account,
        };

        const response = await counterpartiesApi.create(
          this.companyId,
          payload
        );

        const counterpartyId = response.data.result.id;

        await this.$refs.requisiteCreateRef.createRequisites(
          counterpartyId
        );

        this.notificationStore.showSuccess(
          "Новый контрагент успешно создан"
        );

        this.$router.push({
          name: "CounterpartyDetails",
          params: { id: counterpartyId },
        });
      } catch (error) {
        console.error("Ошибка при создании контрагента:", error);
      } finally {
        this.isSubmitting = false;
      }
    },

    handleCancel() {
      this.$router.push({ name: "Counterparties" });
    },
  },

  created() {},
};
</script>

<style scoped>
.counterparty-title,
.counterparty-block {
  margin-bottom: var(--base-out-indent);
}
</style>
